import { render, staticRenderFns } from "./TaskHistoryPopup.vue?vue&type=template&id=21430e39&scoped=true&lang=html"
import script from "./TaskHistoryPopup.vue?vue&type=script&lang=js"
export * from "./TaskHistoryPopup.vue?vue&type=script&lang=js"
import style0 from "./TaskHistoryPopup.vue?vue&type=style&index=0&id=21430e39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21430e39",
  null
  
)

export default component.exports